module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content pt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-orders"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.cotizaciones), function(data) {
    return _c('tr', {
      key: data
    }, [_c('td', [(data.url === 'vacío') ? _c('a', {
      staticClass: "line-clamp-2"
    }, [_vm._v("\n                Precio : " + _vm._s(data.price) + " "), _c('br'), _vm._v("\n                Peso : " + _vm._s(data.weight) + "\n              ")]) : _c('a', {
      staticClass: "line-clamp-2 link",
      attrs: {
        "target": "_blank",
        "href": data.url
      }
    }, [_vm._v("\n                " + _vm._s(data.url) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "180px"
      }
    }, [_c('p', {
      staticClass: "user"
    }, [_vm._v("\n                " + _vm._s(data.id_order ? "Convertido en Orden" : "Simple cotización") + "\n              ")])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.id_order) + "\n            ")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            idUser: data.idUsuario
          },
        },
        "target": "_Blank"
      }
    }, [_vm._v("\n                " + _vm._s(data.idUsuario))])], 1), _vm._v(" "), _c('td', [(data.idStore === 1) ? _c('span', [_vm._v("SENDI")]) : (data.idStore === 2) ? _c('span', [_vm._v("ENVIOS")]) : (data.idStore === null) ? _c('span', [_vm._v("\n                " + _vm._s(data.id_order) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.created_at))])])
  }), 0)])])]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPurchaseOrdersByPage
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex justify-content-between px-3"
  }, [_c('h2', {
    staticClass: "form-title-principal form-title"
  }, [_vm._v("Cotizaciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Link cotizado")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("ID de la orden")]), _vm._v(" "), _c('th', [_vm._v("ID del usuario")]), _vm._v(" "), _c('th', [_vm._v("Store")]), _vm._v(" "), _c('th', [_vm._v("Fecha")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3851f60a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Cotizaciones.vue
// module id = 1868
// module chunks = 1